export default "__VITE_ASSET__CVCRTi7H__"